import { Habit, ID, Insights, InsightSections } from '@griply/types';

import { getActiveSchedule } from '../get-active-schedule';
import { sortItems } from '../sort-items';

export type GetInsightsHabitsOptions = {
  habits: Habit[];
  today: Date;
  insightsSettings: Insights | null | undefined;
  habitSorting: ID[];
};

export const getInsightsHabits = ({
  habits,
  today,
  insightsSettings,
  habitSorting,
}: GetInsightsHabitsOptions): Habit[] => {
  const habitsSectionSettings =
    insightsSettings?.sections?.[InsightSections.Habits];
  const showHiddenItems = insightsSettings?.showHiddenItems ?? false;

  const filteredHabits = habits.filter(
    ({ id, completedAt, archivedAt, parentIds, schedules }) => {
      const activeSchedule = getActiveSchedule(schedules, today);

      return (
        !!activeSchedule &&
        (showHiddenItems ||
          !habitsSectionSettings?.hiddenItems?.includes(id)) &&
        !parentIds?.length &&
        !archivedAt &&
        !completedAt
      );
    },
  );

  const sortedHabits = sortItems(filteredHabits, habitSorting, 'id');

  if (habitsSectionSettings?.order?.length) {
    return sortItems(
      sortedHabits,
      habitsSectionSettings.order,
      'id',
    ) as Habit[];
  }

  return sortedHabits as Habit[];
};
